import { applyMiddleware, compose, legacy_createStore as createStore } from "redux";
import thunk from "redux-thunk";
import rootReducers from "./reducers";

const DEFAULT_STATE = {};

const store = createStore(rootReducers, DEFAULT_STATE, compose(applyMiddleware(thunk)));

export default store;